export type DashboardTimeWindow = 7 | 14 | 30;

export interface DashboardDateAxis {
  range: [string, string];
  tickValues: string[];
  tickLabels: string[];
}

export function createDashboardDateAxis(
  dayCount: DashboardTimeWindow,
  today: Date,
  locale: string,
  chartWidth: number
): DashboardDateAxis {
  const endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const startDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() - dayCount);
  const dates = Array.from(
    { length: dayCount },
    (_, index) => new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + index)
  );
  const maxTickCount = dayCount === 30
    ? dayCount
    : Math.min(dayCount, Math.max(2, Math.floor(chartWidth / 75)));
  const tickIndexes = Array.from(
    { length: maxTickCount },
    (_, index) => Math.round(index * (dayCount - 1) / (maxTickCount - 1))
  );
  const formatter = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });

  return {
    range: [formatLocalDate(startDate), formatLocalDate(endDate)],
    tickValues: tickIndexes.map(index => formatLocalDate(dates[index])),
    tickLabels: tickIndexes.map(index => formatter.format(dates[index]))
  };
}

function formatLocalDate(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${date.getFullYear()}-${month}-${day}`;
}
